import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Solutions } from "@/components/Solutions";
import { WhyTPSSection } from "@/components/WhyTPSSection";
import { ServicesSection } from "@/components/ServicesSection";
import { AdjusterServicesSection } from "@/components/AdjusterServicesSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { ComplianceSection } from "@/components/ComplianceSection";
import { Footer } from "@/components/Footer";
import { SEO, organizationSchema, websiteSchema, localBusinessSchema } from "@/components/SEO";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Index = () => {
  const location = useLocation();

  // Handle hash-based scrolling on mount and hash change
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location.hash]);

  return (
    <>
      <SEO
        canonicalUrl="/"
        structuredData={[organizationSchema, websiteSchema, localBusinessSchema]}
      />
      <div className="min-h-screen">
        <Navigation />
        <main id="main-content" role="main" aria-label="Main content">
          <Hero />
          <WhyTPSSection />
          <Solutions />
          <ServicesSection />
          <AdjusterServicesSection />
          <TestimonialsSection />
          <ComplianceSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
